import { last, get } from 'lodash';
import app from '../../../scripts/app';
import {
  setGeoObject,
  locationPathChanged,
  addressChanged as addressChangedEvent,
  addressSelect,
} from '../../../blocks/segments/address/address.events';
import { INITIAL_GEO_OBJECT } from '../../../scripts/enums/geo-object';

/**
 * Сервис для работы с адресом - сюда надо перенести всю работу с геокодером из директивы адреса.
 * todo: инф., которой не хватает в объявлении при открытии на редактирование:
 * - locationPath - нужен в качестве параметра для апи pub-avail, terms, photos (перепроверить, похоже, что это уже есть)
 * - locationId (сейчас сохраняется только последний в цепочке) - нужен самый первый locationId, для случаев где логика зависит от региона (перепроверить, похоже, что это уже есть)
 * - hasMetro - нужно ли показывать метро
 * сейчас для всего этого при открытии на ред. делается запрос к геокодеру
 */
app.service('addressService', [
  '$rootScope',
  'addFormService',
  'geoService',
  function ($rootScope, addFormService, geoService) {
    let currentAddress;
    let currentJkGeo;
    this.locationId = undefined;
    // Храним locationPath в порядке ChildToParent (от дома к региону), например [дом, район, регион]
    this.locationPath = undefined;
    this.locationPathAsArray = undefined;

    this.getLocationId = address => {
      if (address) {
        const location = address.filter(a => a.type === 'location').pop();
        if (location) {
          return location.id;
        }
      }
    };

    /**
     * Берем самую точную локацию, т.е. последний элемент из locationPath
     * @param  {Array} address массив locationPath
     * @return {Number?}
     */
    const getNearestLocation = address => {
      const nearestLocation = last(address) || {};

      return nearestLocation.id;
    };

    $rootScope.$on(locationPathChanged, (event, locationPath) => {
      this.locationPath = locationPath.join(',');
      this.locationPathAsArray = locationPath;
    });

    const sameLocation = (address1, address2) => {
      return getNearestLocation(address1) === getNearestLocation(address2);
    };

    /**
     * Сохраняем адрес, его валидность и соответствующий locationId.
     * @param address Массив адреса из модели (ad.geo.address)
     * @param geoObject Соответствующий geoObject полученный от геокодера
     * @param isValid Валидность адреса, может быть undefined когда изменение адреса проходит без валидации
     */
    this.saveAddress = (address, geoObject, isValid, init, isJk, firstLoad, searchBSByAddress) => {
      const prevAddress = angular.copy(currentAddress);
      currentAddress = address;
      this.setAddressInfo(address);
      this.geoObject = geoObject;
      this.addressIsValid = isValid;

      const addressChanged =
        !angular.equals(address, prevAddress) || (addFormService.isJkCategory() && geoObject.jkHashKey);

      if (addressChanged) {
        const locationChanged = !sameLocation(address, prevAddress);
        triggerAddressChanged(address, geoObject, isValid, locationChanged, init, isJk, firstLoad, searchBSByAddress);
      }

      return addressChanged;
    };

    // сохраняем информацию о текущем адресе
    this.setAddressInfo = address => {
      this.locationId = this.getLocationId(address);

      if (address && address.length) {
        const { type, id } = address[address.length - 1];
        this.geoType = type;
        this.geoId = id;
      } else {
        this.geoType = this.geoId = null;
      }
    };

    this.isHouse = () => this.geoType === 'house';

    this.isLocation = locationId => {
      const isExactLocation = this.locationId === locationId;

      const locationPath = get(this, 'geoObject.locationPath', geoService.getLocationPath());
      const isInLocationPath = locationPath.some(id => id === locationId);

      return isExactLocation || isInLocationPath;
    };

    this.onAddressChanged = handler => $rootScope.$on(addressChangedEvent, (event, ...args) => handler(...args));
    const triggerAddressChanged = (
      address,
      geoObject,
      isValid,
      locationChanged,
      init,
      isJk,
      firstLoad,
      searchBSByAddress,
    ) => {
      // todo: change to emit
      $rootScope.$broadcast(
        addressChangedEvent,
        address,
        geoObject,
        isValid,
        locationChanged,
        init,
        isJk,
        firstLoad,
        searchBSByAddress,
      );
    };

    /**
     * Установить новый адрес на форме, этот метод инициирует геокодинг и изменения на карте
     * @param address новый адрес
     * @param searchBS нужно ли искать БЦ/ТЦ по новому адресу
     */
    this.setAddress = (address, searchBS = true) => {
      $rootScope.$emit(setGeoObject, { address }, searchBS);
    };

    this.getAddress = () => currentAddress;

    /**
     * Сохраняем гео для выбранного ЖК (корпуса) в новостройках
     * @param geo гео из сервиса ЖК, формат: { address: string, coordinates: obj }
     */
    this.setJkGeo = geo => {
      currentJkGeo = geo;
    };

    this.getJkGeo = () => currentJkGeo;

    this.isUndergroundEnabled = () => {
      return this.geoObject && this.geoObject.hasMetro;
    };

    this.isHighwayEnabled = () => {
      return (
        this.highwayFieldEnabled &&
        this.geoObject &&
        this.geoObject.locationPath &&
        (this.geoObject.locationPath.indexOf(1) > -1 || this.geoObject.locationPath.indexOf(4593) > -1)
      );
    };

    this.getUserInput = () => get(addFormService.ad, 'geo.userInput', '');

    this.setUserInput = userInput => {
      addFormService.setValueByPath('geo.userInput', userInput);

      $rootScope.$emit(addressSelect);
    };

    this.setDefaultGeoObject = () => {
      if (addFormService.isFieldExisted('geo')) {
        return;
      }

      const defaultUserCity = get(geoService, 'userGeo.name', 'Москва');
      const defaultUserInput = `Россия, ${defaultUserCity} `;

      const initialGeoObject = {
        ...INITIAL_GEO_OBJECT,
        userInput: defaultUserInput,
      };

      addFormService.setValueByPath('geo', initialGeoObject);
    };

    $rootScope.$on('addform.clear', () => {
      currentAddress = null;
      this.geoObject = null;
    });
  },
]);
